import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=410a8be1&lang=pug&"
import script from "./transaction.vue?vue&type=script&lang=coffee&"
export * from "./transaction.vue?vue&type=script&lang=coffee&"
import style0 from "./transaction.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports